import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../constants/config';


const PaymentCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [message, setMessage] = useState('Verifying your payment...');
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const verifyPayment = async () => {
      const params = new URLSearchParams(location.search);

      const reference =
        params.get('reference') ||
        params.get('trxref');

      if (!reference) {
        if (!cancelled) {
          setError(true);
          setMessage(
            'Payment reference was not found. We cannot verify this payment.'
          );
        }
        return;
      }

      const token = localStorage.getItem('token');

      if (!token) {
        if (!cancelled) {
          setError(true);
          setMessage(
            'Your session has expired. Please log in again to view your order.'
          );
        }
        return;
      }

      try {
        const response = await axios.get(
          `${API_URL}/payments/paystack/verify/${encodeURIComponent(
            reference
          )}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (cancelled) return;

        if (response.data?.success) {
          setMessage(
            response.data?.message ||
              'Payment verified successfully. Redirecting to your orders...'
          );

          setTimeout(() => {
            if (!cancelled) {
              navigate('/my-orders', { replace: true });
            }
          }, 1500);

          return;
        }

        setError(true);
        setMessage(
          response.data?.message ||
            'We could not verify your payment.'
        );
      } catch (err: any) {
        if (cancelled) return;

        console.error(
          'Payment callback verification error:',
          err?.response?.data || err
        );

        setError(true);

        setMessage(
          err?.response?.data?.message ||
            'Payment verification failed. Please check My Orders before attempting another payment.'
        );
      }
    };

    verifyPayment();

    return () => {
      cancelled = true;
    };
  }, [location.search, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#f8f9fa',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '520px',
          background: '#ffffff',
          borderRadius: '16px',
          padding: '40px 28px',
          textAlign: 'center',
          boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
        }}
      >
        {!error ? (
          <>
            <div
              style={{
                width: '56px',
                height: '56px',
                margin: '0 auto 20px',
                border: '5px solid #e5e7eb',
                borderTopColor: '#2563eb',
                borderRadius: '50%',
                animation: 'paymentSpin 1s linear infinite',
              }}
            />

            <h2
              style={{
                marginBottom: '12px',
                fontSize: '24px',
                fontWeight: 700,
                color: '#111827',
              }}
            >
              Verifying Payment
            </h2>
          </>
        ) : (
          <>
            <div
              style={{
                width: '56px',
                height: '56px',
                margin: '0 auto 20px',
                borderRadius: '50%',
                background: '#fee2e2',
                color: '#b91c1c',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '28px',
                fontWeight: 700,
              }}
            >
              !
            </div>

            <h2
              style={{
                marginBottom: '12px',
                fontSize: '24px',
                fontWeight: 700,
                color: '#111827',
              }}
            >
              Payment Verification
            </h2>
          </>
        )}

        <p
          style={{
            margin: 0,
            color: '#4b5563',
            lineHeight: 1.6,
            fontSize: '16px',
          }}
        >
          {message}
        </p>

        {error && (
          <button
            type="button"
            onClick={() => navigate('/my-orders')}
            style={{
              marginTop: '24px',
              padding: '12px 24px',
              border: 'none',
              borderRadius: '8px',
              background: '#111827',
              color: '#ffffff',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: 600,
            }}
          >
            Go to My Orders
          </button>
        )}

        <style>
          {`
            @keyframes paymentSpin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default PaymentCallback;